import { ATS_API_URL, OLD_DOCUPLOAD_API } from "../../config";
import baseDataProvider, { httpClient } from "../baseDataProvider";
import { assertDocumentRestoreCapacity } from '../documentRestoreCapacity';
const API_URL = ATS_API_URL;
const API_URL_DOC = `${API_URL}/applicant`;


const update = async (resource, params) => {
    if (resource == 'predefinedmessageAdmin') {
      try {
        const { json, headers, status }: any = await httpClient(
          `${API_URL}/admin/predefinedmessages/${params.id}`,
          {
            method: "PUT",
            body: JSON.stringify(params?.data),
          }
        );
        return json;
      } catch (e: any) {
        throw new Error(e.message);
      }
    } else
      if (resource == 'predefinedmessage') {
        try {
          const { json, headers, status }: any = await httpClient(
            `${API_URL}/subscriber/addpredefinedmessages/${params.id}`,
            {
              method: "PUT",
              body: JSON.stringify(params?.data),
            }
          );
          return json;
        } catch (e: any) {
          throw new Error(e.message);
        }
      } else
        if (resource == "update-user") {
          try {
            const { json, headers, status }: any = await httpClient(
              `${API_URL}/subscriber/registeruser`,
              {
                method: "PUT",
                body: JSON.stringify(params?.data),
              }
            );
            return {
              data: { id: 1, ...json },
            };
          } catch (e: any) {
            throw new Error(e.message);
          }
        }
    //update role for permisions
    if (resource == "update-permission") {
      try {
        const { json, headers, status }: any = await httpClient(
          `${API_URL}/subscriber/addrole`,
          {
            method: "PUT",
            body: JSON.stringify(params?.data),
          }
        );
        return {
          data: { id: 1, ...json },
        };
      } catch (e: any) {
        throw new Error(e.message);
      }
    }
    //update role for admin third party
    if (resource == "updatethirdpartypermissions") {
      try {
        const { json, headers, status }: any = await httpClient(
          `${API_URL}/admin/updatethirdpartypermissions`,
          {
            method: "PUT",
            body: JSON.stringify(params?.data),
          }
        );
        return {
          data: { id: 1, ...json },
        };
      } catch (e: any) {
        throw new Error(e.message);
      }
    }
    if (resource == "update-admin-permission") {
      try {
        const { json, headers, status }: any = await httpClient(
          `${API_URL}/admin/addrole`,
          {
            method: "PUT",
            body: JSON.stringify(params?.data),
          }
        );
        return {
          data: { id: 1, ...json },
        };
      } catch (e: any) {
        throw new Error(e.message);
      }
    }
    if (resource == "update-admin-user") {
      try {
        const { json, headers, status }: any = await httpClient(
          `${API_URL}/admin/register`,
          {
            method: "PUT",
            body: JSON.stringify(params?.data),
          }
        );
        return {
          data: { id: 1, ...json },
        };
      } catch (e: any) {
        throw new Error(e.message);
      }
    }
    if (resource == "update-adverse-letter-details") {
      try {
        const { json, headers, status }: any = await httpClient(
          `${API_URL}` + `/subscriber/updateadverseletter`,
          {
            method: "PUT",
            body: JSON.stringify(params?.data),
          }
        );
        return {
          data: { id: 1, ...json },
        };
      } catch (e: any) {
        throw new Error(e.message);
      }
    }


    if (resource === "unarchive") {
      const raw = JSON.stringify({ ...params.data });
      try {
        const { json, headers, status, error }: any = await httpClient(
          API_URL + "/subscriber/unarchive/" + params.id,
          {
            method: "PUT",
            body: raw,
          }
        );
        const r = json;
        const res = {
          data: {
            id: params.data.trn_id,
            ...r.records,
          },
        };
        return res;
      } catch (e: any) {
        throw new Error(e.message);
      }
    }
    if (resource === "mlclassdetails") {
      try {
        const { json }: any = await httpClient(
          `${API_URL_DOC}/ml` + `/updatePaystubTemplate`,
          {
            method: "POST",
            body: JSON.stringify(params.data),
          }
        );
        const r = json;
        const res = {
          data: {
            ...r.records,
          },
        };
        return res;
      } catch (e: any) {
        throw new Error(e.message);
      }
    }





    if (resource === "applicant") {
      //
      const subUrl = params.data.subUrl;
      delete params.data.subUrl;
      const raw = JSON.stringify({ ...params.data });
      try {
        const { json, headers, status }: any = await httpClient(
          API_URL_DOC + `/applicant/docupload${subUrl}`,
          {
            method: "POST",
            body: raw,
          }
        );
        const r = json;
        const res = {
          data: {
            id: params.data.trn_id,
            ...r.records,
          },
        };
        return res;
      } catch (e: any) {
        throw new Error(e.message);
      }
    }

    if (resource === "other_sections") {
      const subUrl = params.data.subUrl;
      delete params.data.subUrl;
      const raw = JSON.stringify({ ...params.data });
      try {
        // 
        const { json, headers, status }: any = await httpClient(
          API_URL_DOC + `${subUrl}`,
          {
            method: "POST",
            body: raw,
          }
        );
        const r = json;
        const res = {
          data: {
            id: params.data.trn_id,
            ...r.records,
          },
        };
        return res;
      } catch (e: any) {
        throw new Error(e.message);
      }
    }

    if (resource === "deletedDocument") {
      await assertDocumentRestoreCapacity(params.data);
      const raw = JSON.stringify({ ...params.data });
      try {
        const { json, headers, status, error }: any = await httpClient(
          API_URL_DOC + "/document/deletedDocument/" + params.id,
          {
            method: "PUT",
            body: raw,
          }
        );
        const r = json;
        const res = {
          data: {
            id: params.data.trn_id,
            ...r.records,
          },
        };
        return res;
      } catch (e: any) {
        throw new Error(e.message);
      }
    }

    if (resource == "archive") {
      try {
        const { json }: any = await httpClient(
          `${API_URL}/subscriber/archive/${params.id}`,
          {
            method: "PUT",
            body: JSON.stringify(params.data),
          }
        );
        const res = json;
        return {
          data: { id: res.data[0].ApplicationNumber, ...res.data[0] },
        };
      } catch (e: any) {
        throw new Error(e.message);
      }
    }

    if (resource == "editapplicationdetail") {
      try {
        const { json }: any = await httpClient(
          `${API_URL}/common/editapplicationdetail/${params.id}`,
          {
            method: "PUT",
            body: JSON.stringify(params.data),
          }
        );
        const res = json;
        // need to check new response body res.data[0].ApplicationNumber
        return {
          data: { id: params?.id, ...res.data },
        };
      } catch (e: any) {
        throw new Error(e.message);
      }
    }

    if (resource == "editapplicantDetails") {
      try {
        const { json }: any = await httpClient(
          `${API_URL}/common/editapplicantDetails/${params.id}`,
          {
            method: "PUT",
            body: JSON.stringify(params.data),
          }
        );
        const res = json;
        return {
          data: { id: params?.id, ...res.data },
        };
      } catch (e: any) {
        throw new Error(e.message);
      }
    }

    if (resource == "tranferapp") {
      try {
        const { json }: any = await httpClient(
          `${API_URL}/subscriber/tranferapp/${params.id}`,
          {
            method: "PUT",
            body: JSON.stringify(params.data),
          }
        );
        const res = json;
        return {
          data: { id: res.data[0].ApplicationNumber, ...res.data[0] },
        };
      } catch (e: any) {
        throw new Error(e.message);
      }
    }
    if (resource == "switchApplicant") {
      try {
        const { json }: any = await httpClient(
          `${API_URL}/subscriber/switchrole`,
          {
            method: "POST",
            body: JSON.stringify(params.data),
          }
        );
        const res = json;
        return {
          data: { id: params.data.ApplicationNumber, ...res.data },
        };
      } catch (e: any) {
        throw new Error(e.message);
      }
    }
    if (resource == "removeapplicant") {
      try {
        const { json }: any = await httpClient(
          `${API_URL}/subscriber/removeapplicant/${params.id}`,
          {
            method: "PUT",
            body: JSON.stringify(params.data),
          }
        );
        const res = json;
        return {
          data: { id: params.id, ...res.data[0] },
        };
      } catch (e: any) {
        throw new Error(e.message);
      }
    }
    if (resource == "cancelapp") {
      try {
        const { json }: any = await httpClient(
          `${API_URL}/subscriber/cancelapp/${params.id}`,
          {
            method: "PUT",
          }
        );
        const res = json;
        return {
          data: { id: res.data[0].ID, ...res.data[0] },
        };
      } catch (e: any) {
        throw new Error(e.message);
      }
    }
    if (resource == "readdapplicant") {
      try {
        const { json }: any = await httpClient(
          `${API_URL}/subscriber/readdapplicant/${params.id}`,
          {
            method: "PUT",
            body: JSON.stringify(params.data),
          }
        );
        const res = json;
        return {
          data: { id: res.data[0].ID, ...res.data[0] },
        };
      } catch (e: any) {
        throw new Error(e.message);
      }
    }
    return baseDataProvider.update(resource, params);
  }

export default update;
